<template>
  <div>
    <TituloPagina :titulo="tituloDaPagina" />

    <p
      class="pa-0 mt-5 mb-6 primary--text"
      data-cy="texto_da_pagina"
    >
      {{ textoDaPagina }}
    </p>

    <div class="body-2 pb-1">
      <p
        class="mb-3"
        data-cy="favorecido_nome"
      >
        Nome <strong class="grey--text text--darken-2">
          {{ dadosBancarios.full_name }}
        </strong>
      </p>

      <p
        class="mb-3"
        data-cy="favorecido_cpf_cnpj"
      >
        CPF/CNPJ <strong class="grey--text text--darken-2">
          {{ dadosBancarios.federal_tax_number }}
        </strong>
      </p>

      <p
        class="mb-3"
        data-cy="banco_nome"
      >
        Banco <strong class="grey--text text--darken-2">
          {{ dadosBancarios.bank_name }}
        </strong>
      </p>

      <p
        class="mb-3"
        data-cy="banco_tipo_conta"
      >
        Tipo de Conta <strong class="grey--text text--darken-2">
          {{ tipoConta }}
        </strong>
      </p>

      <p
        class="mb-3"
        data-cy="banco_agencia"
      >
        Agência <strong class="grey--text text--darken-2">
          {{ agencia }}
        </strong>
      </p>

      <p
        class="mb-3"
        data-cy="banco_conta_corrente"
      >
        Conta <strong class="grey--text text--darken-2">
          {{ contaCorrente }}
        </strong>
      </p>

      <p
        v-if="dadosBancarios.operation_type"
        class="mb-3"
        data-cy="banco_operacao"
      >
        Op <strong class="grey--text text--darken-2">
          {{ dadosBancarios.operation_type }}
        </strong>
      </p>
    </div>

    <v-btn
      block
      outlined
      color="primary"
      class="mb-12"
      data_cy="alterar_dados"
      @click="mudarDados()"
    >
      Alterar dados bancários
    </v-btn>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import TituloPagina from '@/components/TituloPagina.vue';

export default {
  name: 'PassoConferirDadosBancarios',

  components: {
    TituloPagina,
  },

  props: {
    dadosBancarios: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tituloDaPagina: 'Dados bancários',
      textoDaPagina: 'Dados da última solicitação de reembolso:',
    };
  },

  computed: {
    ...mapGetters(['dadosCompra', 'alterarDadosBancarios']),

    contaCorrente() {
      const dadosDoBanco = this.dadosBancarios;
      return dadosDoBanco.account_number_suffix
        ? `${dadosDoBanco.account_number}-${dadosDoBanco.account_number_suffix}`
        : dadosDoBanco.account_number;
    },

    tipoConta() {
      return this.dadosBancarios.account_type === '1' ? 'Corrente' : 'Poupança';
    },

    agencia() {
      const dadosDoBanco = this.dadosBancarios;
      return dadosDoBanco.bank_branch_suffix
        ? `${dadosDoBanco.bank_branch}-${dadosDoBanco.bank_branch_suffix}`
        : dadosDoBanco.bank_branch;
    },
  },

  methods: {
    ...mapActions(['setAlterarDadosBancarios']),

    mudarDados() {
      this.setAlterarDadosBancarios(true);
      this.$emit('mudarDadosBancarios', true);
    },
  },

};
</script>
